import React, { useEffect, forwardRef } from 'react'
import { useFormContext } from 'react-hook-form'
import { Input } from '@/client/components/Input'
import { Props } from './types'

export const ControlledInput = forwardRef<HTMLInputElement, Props>(
  ({ name, formatter, registerOptions, forceError, ...rest }, ref) => {
    const {
      register,
      watch,
      setValue,
      formState: { errors }
    } = useFormContext()

    const watcher = watch(name)

    useEffect(() => {
      if (!formatter) return
      const value = watcher || ''
      const formatted = formatter(value)
      // Only update when formatting actually changes the value, so we don't validate untouched fields
      if (formatted !== value) {
        setValue(name, formatted, { shouldValidate: true, shouldDirty: true })
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [watcher, formatter, setValue, name])

    const errorMessage = errors?.[name]?.message

    return (
      <Input
        ref={ref}
        hasError={!!errorMessage || forceError}
        error={errorMessage && String(errorMessage)}
        register={register(name, registerOptions)}
        {...rest}
      />
    )
  }
)

ControlledInput.displayName = 'ControlledInput'
